import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './skip-to-content.scss.js';

class SkipToContent extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
    }
    render() {
        return x `<a href="#skip-to-content" class="skip-to-content${this.rtl || isRTL() ? ' rtl' : ''}"><slot name="text"></slot><div class="link"><slot name="link"></slot></div></a>`;
    }
}
SkipToContent.styles = css_248z;
__decorate([
    n({ type: Boolean })
], SkipToContent.prototype, "rtl", void 0);
customElements.define('skip-to-content', SkipToContent);

export { SkipToContent };
